"use client";

import { ArrowRight, Code2 } from "lucide-react";
import Link from "next/link";
import type { ReactElement } from "react";
import { careersEngineeringHref } from "./careers-constants";
import { CAREERS_CONTENT } from "./careers-content";
import { useCareersLanguage } from "./careers-language-context";

/** Slim callout band routing software developers to their dedicated apply page. */
export function CareersDevTeaser(): ReactElement {
  const { lang } = useCareersLanguage();
  const t = CAREERS_CONTENT[lang].teaser;

  return (
    <section className="dvf-section c2-section-slim">
      <div className="c2-teaser">
        <span className="dvf-bullet-icon">
          <Code2 size={20} strokeWidth={1.9} aria-hidden={true} />
        </span>
        <h2 className="c2-teaser-title">
          <span className="c2-teaser-accent">{t.accent}?</span>
          {t.rest}
          <span className="c2-teaser-point" aria-hidden={true}>
            {" "}
            👉
          </span>
        </h2>
        <Link href={careersEngineeringHref()} className="c2-btn">
          {t.cta}
          <ArrowRight className="c2-teaser-arrow" size={16} strokeWidth={2.2} />
          <span className="c2-teaser-point-btn" aria-hidden={true}>
            👉
          </span>
        </Link>
      </div>
    </section>
  );
}
